import React from 'react'
import { ActionButton, MainPagination } from './styles'

const WINDOW_SIZE = 10

const TablePaginationActions = (props: any) => {
  const { count, page, rowsPerPage, onPageChange } = props

  const totalPages = Math.ceil(count / rowsPerPage)

  const half = Math.floor(WINDOW_SIZE / 2)
  let startPage = Math.max(0, page - half)
  let endPage = Math.min(totalPages - 1, startPage + WINDOW_SIZE - 1)

  // ajusta a janela quando está próxima do final
  if (endPage - startPage < WINDOW_SIZE - 1) {
    startPage = Math.max(0, endPage - WINDOW_SIZE + 1)
  }

  function handleGoToPage(pageIndex: number) {
    onPageChange('', pageIndex)
  }

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1)
  }

  const isFirstPage = page === 0
  const isLastPage = page >= totalPages - 1

  return (
    <MainPagination>
      <ActionButton
        onClick={handleBackButtonClick}
        aria-label="previous page"
        disabled={isFirstPage}
      >
        Anterior
      </ActionButton>

      {Array.from({ length: endPage - startPage + 1 }, (_, idx) => {
        const pageIndex = startPage + idx
        return (
          <ActionButton
            key={pageIndex}
            onClick={() => handleGoToPage(pageIndex)}
            style={page === pageIndex ? { border: '1px solid' } : {}}
          >
            {pageIndex + 1}
          </ActionButton>
        )
      })}

      <ActionButton
        onClick={handleNextButtonClick}
        aria-label="next page"
        disabled={isLastPage}
      >
        Próximo
      </ActionButton>
    </MainPagination>
  )
}

export default TablePaginationActions
